import differenceInCalendarDays from 'date-fns/differenceInDays'

export const diffInDays = (startDate, endDate) => {
  return differenceInCalendarDays(new Date(endDate), new Date(startDate))
}
